import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const KEY = "he_cookie_ack";

export default function CookieBanner() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(KEY) !== "true") setOpen(true);
    } catch { /* silent */ }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "true"); } catch { /* silent */ }
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur shadow-2xl">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="grid h-9 w-9 flex-none place-items-center rounded-xl bg-solar-green/10 text-solar-green">
            <Cookie className="h-4 w-4" strokeWidth={2.4} />
          </span>
          <p className="text-sm text-slate-600">
            {t("cookies_banner.body")} <Link to="/cookies" className="text-solar-green underline hover:text-solar-green-dark">{t("cookies_banner.learn_more")}</Link>
          </p>
        </div>
        <div className="flex flex-none items-center gap-2">
          <button type="button" data-testid="cookie-banner-close" onClick={accept} aria-label={t("cookies_banner.close")}
            className="rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-solar-slate">
            <X className="h-4 w-4" />
          </button>
          <button type="button" data-testid="cookie-banner-accept" onClick={accept}
            className="rounded-full bg-solar-green px-4 py-1.5 text-sm font-semibold text-white shadow hover:bg-solar-green-dark">
            {t("cookies_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
